import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay/legacy';

// components
import { FormattedMessage } from 'dibs-react-intl';
import { learnMore } from '../pdpMessages';
import {
    benefitVetted,
    benefitProtection,
    benefitDelivery,
    benefitPriceMatch,
    benefitConfidence,
    benefitSupport,
} from './Benefits/Benefits';

// styles
import styles from './PdpRespBuyerAssuranceBox.scss';

// helpers
import { Link } from 'dibs-elements/exports/Link';
import * as tracking from 'dibs-tracking';

// constants
const LINK_BUYER = '/about/promise/';
const LINK_TRADE = '/info/trade/promise/';

const trackLearnMore = () =>
    tracking.trackEvent({
        action: 'buyer protection',
        label: 'clicked',
        category: 'product',
        value: 0,
    });

export function PdpRespBuyerAssuranceBoxComponent({ user }) {
    const isVerifiedTrade = !!(user && user.isVerifiedTrade);
    const learnMoreLink = isVerifiedTrade ? LINK_TRADE : LINK_BUYER;

    return (
        <div className={styles.wrapper}>
            <div className={styles.container}>
                <h2 className={styles.header}>
                    <FormattedMessage
                        id="PdpRespBuyerAssuranceBox.header"
                        defaultMessage="The 1stDibs Promise"
                    />
                </h2>
                <Link href={learnMoreLink} onClick={trackLearnMore} className={styles.learnMore}>
                    {learnMore}
                </Link>
                {/* Benefits */}
                <div className={styles.benefits}>
                    <div className={styles.benefitColumn}>
                        {benefitVetted}
                        {benefitConfidence}
                    </div>
                    <div className={styles.benefitColumn}>
                        {benefitPriceMatch}
                        {benefitSupport}
                    </div>
                    <div className={styles.benefitColumn}>
                        {benefitProtection}
                        {benefitDelivery}
                    </div>
                </div>
            </div>
        </div>
    );
}

PdpRespBuyerAssuranceBoxComponent.propTypes = {
    user: PropTypes.object,
};

export const PdpRespBuyerAssuranceBox = createFragmentContainer(PdpRespBuyerAssuranceBoxComponent, {
    user: graphql`
        fragment PdpRespBuyerAssuranceBox_user on User {
            isVerifiedTrade
        }
    `,
});
